import AdminService from "services/AdminService"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit" // Créez un service pour l'API admin
import { APP_PREFIX_PATH } from "configs/AppConfig"

export const initialState = {
  admin: {},
  adminCount: null,
  admins: [],
  currentPage: 1,
  deleteModalIsOpen: false,
  doctorCount: null,
  doctorsByState: [],
  DrawerInfoIsOpen: false,
  loadedPages: [],
  loadedSearchPages: [],
  loading: false,
  message: "",
  redirect: "",
  searchValue: null,
  showMessage: false,
  showMessage: false,
  totalItems: null,
  validateModelOpen: false,
}

export const createAdmin = createAsyncThunk(
  "admin/create",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await AdminService.create(data)
      dispatch(clearStates())
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Error")
    }
  }
)

export const getAllAdmins = createAsyncThunk(
  "admins/getAll",
  async (page, { dispatch, rejectWithValue }) => {
    try {
      const response = await AdminService.getAll(page)
      // dispatch(addPage(page))
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)
export const getAdminById = createAsyncThunk(
  "Admin/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AdminService.getById(id)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)
export const searchAdmins = createAsyncThunk(
  "admin/search",
  async ({ page = 1, value }, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setCurrentPage(page))
      const response = await AdminService.search(page, value)
      dispatch(clearStates())
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)

export const deleteAdminById = createAsyncThunk(
  "Admin/delete",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await AdminService.deleteById(id)
      dispatch(clearStates())
      dispatch(setCurrentPage(1))
      dispatch(getAllAdmins(1))
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)

export const getMyProfile = createAsyncThunk(
  "admin/getById",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AdminService.getMyProfile()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur")
    }
  }
)
export const editMyProfile = createAsyncThunk(
  "admin/editMyProfile",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AdminService.editMyProfile(data)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur")
    }
  }
)

export const getStatistics = createAsyncThunk(
  "admin/getStatistics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AdminService.getStatistics()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur")
    }
  }
)

export const nombreDoctorByState = createAsyncThunk(
  "admin/nombreDoctorsByState",
  async (_, { rejectWithValue }) => {
    try {
      const response = await AdminService.getNombreDoctorsByState()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur")
    }
  }
)
export const adminSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(createAdmin.pending, (state) => {
        state.loading = true
      })
      .addCase(createAdmin.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = `${APP_PREFIX_PATH}/admins`
      })
      .addCase(createAdmin.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(getAllAdmins.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllAdmins.fulfilled, (state, action) => {
        state.loading = false
        state.admins = action.payload.data
        state.totalItems = action.payload.totalItems
      })
      .addCase(getAllAdmins.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })

      .addCase(searchAdmins.pending, (state) => {
        state.loading = true
      })
      .addCase(searchAdmins.fulfilled, (state, action) => {
        state.loading = false
        state.admins = action.payload.data
        state.totalItems = action.payload.totalItems
      })
      .addCase(searchAdmins.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(deleteAdminById.pending, (state) => {
        state.loading = true
        state.deleteModalIsOpen = false
      })
      .addCase(deleteAdminById.fulfilled, (state, action) => {
        state.loading = false
        state.deleteModalIsOpen = false
      })
      .addCase(deleteAdminById.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
        state.deleteModalIsOpen = false
      })
      .addCase(getMyProfile.pending, (state) => {
        state.loading = true
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.loading = false
        state.admin = action.payload
      })
      .addCase(getMyProfile.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })
      .addCase(editMyProfile.pending, (state) => {
        state.loading = true
      })
      .addCase(editMyProfile.fulfilled, (state, action) => {
        state.loading = false
        state.admin = action.payload.admin
        state.showMessage = true
      })
      .addCase(editMyProfile.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })
      .addCase(getStatistics.pending, (state) => {
        state.loading = true
      })
      .addCase(getStatistics.fulfilled, (state, action) => {
        state.loading = false
        state.adminCount = action.payload.adminCount
        state.doctorCount = action.payload.doctorCount
        state.showMessage = true
      })
      .addCase(getStatistics.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })

      .addCase(nombreDoctorByState.pending, (state) => {
        state.loading = true
      })
      .addCase(nombreDoctorByState.fulfilled, (state, action) => {
        state.loading = false
        state.doctorsByState = action.payload
        state.showMessage = true
      })
      .addCase(nombreDoctorByState.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })
  },
  initialState,
  name: "admin",
  reducers: {
    clearStates: (state) => {
      state.admins = []
      // state.currentPage = 1
      state.totalItems = null
    },
    hideAdminMessage: (state) => {
      state.message = ""
      state.showMessage = false
    },
    setAdminInfo: (state, action) => {
      state.admin = action.payload
    },

    setBanModel: (state, action) => {
      state.bannedModelOpen = action.payload.etat
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },

    setDrawerInfo: (state, action) => {
      state.DrawerInfoIsOpen = action.payload.etat
    },
    setRedirect: (state, action) => {
      state.redirect = action.payload
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload
    },
    setValidateModel: (state, action) => {
      state.validateModelOpen = action.payload.etat
    },
    showAdminMessage: (state, action) => {
      state.message = action.payload
      state.showMessage = true
      state.loading = false
    },
    showDeleteModal: (state, action) => {
      state.deleteModalIsOpen = action.payload.etat
    },

    showLoading: (state) => {
      state.loading = true
    },
  },
})

export const {
  clearStates,
  hideAdminMessage,
  setAdminInfo,
  setBanModel,
  setCurrentPage,
  setDrawerInfo,
  setRedirect,
  setSearchValue,
  setValidateModel,
  showAdminMessage,
  showDeleteModal,
  showLoading,
} = adminSlice.actions

export default adminSlice.reducer
